<template>
  <div>
    <div class="control is-grouped">
      <input v-model="searchName" class="input searchFilter" type="text" :placeholder="$t('campaigns.putCampaignsName')">
      <button class="button is-info is-outlined" v-on:click="loadData()">
        <span class="icon">
          <i class="fa fa-search"></i>
        </span>
        <span>{{$t('common.search')}}</span>
      </button>

    </div>

    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <div class="paging-top">
            <Paging :refresh="loadData" :per-page="perPage" :data.sync="campaignsPage" :pagingClass="'top'"/>
          </div>
          <div class="table-responsive">
            <table class="table is-bordered is-striped is-narrow campaignsTable">
              <thead>
              <tr>
                <th>{{$t('common.title')}}</th>
                <th class="client" v-if="canSelectUser(permissionKey)">{{$t('common.client')}}</th>
                <th>{{$t('scenarios.scenario')}}</th>
                <th>{{$t('common.state')}}</th>
                <th>{{$t('campaigns.loadBase')}}</th>
                <th>{{$t('campaigns.report')}}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(campaign, index) in campaignsPage.content">
                <td class="campaignNameCell">
                  <a :href="'#/campaigns/'+campaign.id">{{campaign.name}}</a>
                </td>
                <td class="clientNameCell" v-if="canSelectUser(permissionKey)">
                  <a :href="'#/users/client/'+campaign.clientId">{{campaign.client}}</a>
                </td>
                <td class="scenarioNameCell">
                  <a :href="'#/scenarios/'+campaign.id+'/'+campaign.scenario">{{campaign.scenarioName}}</a>
                </td>
                <td class="campaignStatusCell">
                    <span>{{$t(getCampaignStateInfoTrans(campaign))}}</span>
                    <button v-if="canSetReadyStatus(campaign)" :disabled="!isActive" class="button is-info" v-on:click="setReadyStatus(campaign)"   >
                        <span class="icon">
                          <i class="fa fa-check-circle"></i>
                        </span>
                      <span>{{$t('common.actions.run')}}</span>
                    </button>
                    <button v-if="canPauseStatus(campaign)" class="button is-info" v-on:click="setPauseStatus(campaign)" >
                        <span class="icon">
                          <i class="fa fa-stop-circle"></i>
                        </span>
                      <span>{{$t('common.actions.stop')}}</span>
                    </button>
                </td>
                <td class="loadPhonesCell">
                  <div>
                    <input class="button is-info" type="button" :value="$t('common.actions.loadFromFile')" @click="uploadFile('uploadPhones'+index)">
                    <input style="display:none;" @input="uploadPhones('uploadPhones'+index, campaign)" :id="`uploadPhones`+index" name="load-phones" type="file" accept=".txt,.csv,.xls,.xlsx">
                  </div>
                  <div v-if="canDeletePhones(campaign)" class="deletePhonesDiv" v-on:click="openModalDeletePhones(campaign)">
                    <button v-if="" class="button delete-button is-dark">
                      <span>{{$t('campaigns.report')}}</span>
                    </button>
                  </div>
                </td>
                <td class="campaignReportCell">
                  <div class="control">
                    <input class="input reportPeriod" type="date" v-model="reportPeriodStart[index]"/>
                    <input class="input reportPeriod" type="date" v-model="reportPeriodEnd[index]"/>
                    <button class="button is-info" v-on:click="getReportCSV(campaign, formatPeriodDate(reportPeriodStart[index]), formatPeriodDate(reportPeriodEnd[index]))">
                        <span class="icon">
                          <i class="fa fa-download"></i>
                        </span>
                      <span>{{$t('common.actions.load')}} CSV</span>
                    </button>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="paging-bottom">
            <Paging :refresh="loadData" :per-page="perPage" :data.sync="campaignsPage" :pagingClass="'bottom'"/>
          </div>
        </article>
        <modal :visible="showModal" :title=title :confirmation=confirmation :clipboard=false @confirm="confirmAction" @close="closeModal"></modal>
      </div>
    </div>
  </div>
</template>

<script>
    const CAMPAIGN_API = '/api/campaigns'
    const PHONEBASEUPLOADING_API = '/outgoing-cpg-sec'

    import Paging from '../../components/Paging'
    import CampaignsCommon from '../CampaignsCommon'

    export default {
        extends: CampaignsCommon,
        name: 'DailyCampaigns',
        components: {
            Paging
        },
        data () {
            return {
                campaignsPage: { content:[] },
                perPage: 16,
                searchName: '',
                showModal: null,
                title: '',
                actionCampaign: null,
                reportPeriodStart: [],
                reportPeriodEnd: [],
                last24Hours: '',
                now: ''
            }
        },
        created: function () {
            this.last24Hours = this.getLast24Hours()
            this.now = this.getNowDate()
            this.loadData()
        },
        methods: {
            loadData(page) {
                let that = this
                page = page ? (page - 1) : 0
                let url = CAMPAIGN_API + '/filter' + '?page=' + page + '&pageSize=' + this.perPage + '&filter=' + this.searchName + '&scheduleStrategy=DAILY_TIME_INTERVAL,DAILY_TIME_INTERVAL_WITHOUT_TASK_UPDATE&showTasksCount=READY,POSTPONED'
                this.$http.get(url, {headers: this.prepareSecurityHeader()})
                    .then((response) => {
                        that.campaignsPage = response.data
                        that.reportPeriodStart = []
                        that.reportPeriodEnd = []
                        for (let i = 0; i < that.campaignsPage.content.length; i++) {
                            that.reportPeriodStart.push(that.last24Hours)
                            that.reportPeriodEnd.push(that.now)
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        that.openNotificationWithType('danger', 'Ошибка загрузки списка рассылок. ')
                    })
            },
            getLast24Hours() {
                let last24Hours = new Date(new Date().getTime() - (24 * 3600 * 1000))
                let dd = last24Hours.getDate()
                let mm = last24Hours.getMonth() + 1 // January is 0!
                if (dd < 10) {
                    dd = '0' + dd
                }
                if (mm < 10) {
                    mm = '0' + mm
                }
                return last24Hours.getFullYear() + '-' + mm + '-' + dd
            },
            getNowDate() {
                let now = new Date(new Date().getTime())
                let dd = now.getDate()
                let mm = now.getMonth() + 1 // January is 0!
                if (dd < 10) {
                    dd = '0' + dd
                }
                if (mm < 10) {
                    mm = '0' + mm
                }
                return now.getFullYear() + '-' + mm + '-' + dd
            },
            formatPeriodDate(date) {
              if (date) {
                  let split = date.split('-')
                  if (split.length === 3) {
                      return split[2] + '.' + split[1] + '.' + split[0]
                  }
              }
              return ''
            },
            canDeletePhones(campaign) {
                return !campaign.archiveStatus && campaign.tasksCount && campaign.tasksCount.READY > 0
            },
            openModalDeletePhones(campaign) {
                this.actionCampaign = campaign
                this.title = 'удалить номера?'
                this.showModal = true
            },
            confirmAction() {
                this.showModal = false
                if (this.title === 'удалить номера?') {
                    this.deleteReadyTasks()
                }
                this.actionCampaign = null
            },
            deleteReadyTasks() {
                this.$http.delete(`${PHONEBASEUPLOADING_API}/ready/${this.actionCampaign.id}`, {headers: this.prepareSecurityHeader()})
                    .then((response) => {
                        this.openNotificationWithType('info', 'Звонки удалены.')
                    })
                    .catch((error) => {
                        console.log(error)
                        this.openNotificationWithType('danger', 'Ошибка удаления звонков. ')
                    })
            }
        }
    }
</script>

<style scoped>
  .searchFilter {
    max-width: 512px;
    min-width: 256px;
  }
  .reportPeriod {
    max-width: 150px;
  }
  .campaignsTable .button {
    margin-bottom: 0;
  }
  .table {
    margin-bottom:0;
  }
  .campaignStatusCell {
    width: 256px;
  }
  .campaignStatusCell button{
    float: right;
  }
  .loadPhonesCell {
    width: 423px;
  }
  .loadPhonesCell div{
    display: inline-block;
  }
  .loadPhonesCell .deletePhonesDiv{
    margin-left: 8px;
  }
  .campaignReportCell {
    width: 463px;
  }

</style>



// WEBPACK FOOTER //
// DailyCampaigns.vue?08bd6cea